<template>
  <div class="b-menu-breadcrumb" @mouseover="expand" @mouseleave="collapse">
    <div class="b-menu-breadcrumb__items" :style="[minHeight]">
      <b-menu-breadcrumb-item v-for="(item, index) in _items" :key="index" :style="[margin]"
                              :size="itemSize"
                              :color="getColorByIndex(index)"
                              :active="isActive(item)"
                              :title="item.title"
                              @mouseover="setHoverItem(item)"
                              @click="navigateTo(item)">
      </b-menu-breadcrumb-item>
    </div>
    <div class="b-menu-breadcrumb__label">{{ activeItemTitle }}</div>
  </div>
</template>

<script>
import BMenuBreadcrumbItem from './b-menu-breadcrumb-item'

import EventBus, { Events } from '../event-bus'
import RouterHelper from '../util/RouterHelper'
import StoreHelper from '../store/helper'

import _ from 'lodash'

export default {
  name: 'b-menu-breadcrumb',
  components: {
    BMenuBreadcrumbItem
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      expanded: false,
      itemSize: StoreHelper.getBreadcrumbItemSize(),
      hoverItem: null
    }
  },
  methods: {
    expand () {
      this.expanded = true
    },
    collapse () {
      this.expanded = false
      this.setHoverItem(null)
    },
    setHoverItem (item) {
      this.hoverItem = item
    },
    getColorByIndex (index) {
      const colors = StoreHelper.getBreadcrumbColors()
      return colors[index % colors.length]
    },
    isActive (item) {
      return _.isEqual(this.activeItem, item)
    },
    navigateTo (item) {
      const path = _.isEmpty(item.path) ? StoreHelper.getInitialRoutePath() : StoreHelper.getInitialRoutePath() + '/' + item.path
      const route = { path }

      if (RouterHelper.routeExists(this.$router, route)) {
        return RouterHelper.goTo(this.$router, route)
      }

      EventBus.$emit(Events.B_MENU_BREADCRUMB_ITEM_CLICKED, item)
    }
  },
  computed: {
    _items () {
      return StoreHelper.isBreadcrumbShowHomeEnabled() && !StoreHelper.isHomeView()
        ? _.concat([StoreHelper.getBreadcrumbHomeItem()], this.items)
        : this.items
    },
    activeItem () {
      return this.hoverItem || _.last(this._items)
    },
    activeItemTitle () {
      return _.get(this.activeItem, 'title', '')
    },
    margin () {
      return this.expanded ? {} : { marginLeft: `-${this.itemSize/2}px` }
    },
    minHeight () {
      return { minHeight: `${this.itemSize}px` }
    }
  },
  deactivated () {
    this.collapse()
  }
}
</script>

<style lang="scss" scoped>
.b-menu-breadcrumb {
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 15px;

  &__items {
    display: flex;
    align-items: center;
  }

  &__label {
    font-size: 10px;
    margin-left: 10px;
    transition: margin 300ms cubic-bezier(0.49, 0.68, 0.32, 1.31), transform 300ms cubic-bezier(0.49, 0.68, 0.32, 1.31);
  }

  &:hover &__label {
    margin-left: 20px;
  }
}

.b-menu-breadcrumb-item__container:first-child {
  margin-left: 0 !important;
}
</style>
